import React, { useState } from "react";
import { Habit, Day, ReportPeriod, ReportTab } from "../types";
import { NavMenu } from "../components/NavMenu";
import { PeriodSelector } from "../components/PeriodSelector";
import { ScoreHeatmap } from "../components/ScoreHeatmap";
import { BarChart } from "../components/BarChart";
import { ProgressTrackingWidget } from "../components/ProgressTrackingWidget";
import { JournalView } from "./JournalView";
import { getPeriodLabel } from "../utils/periodUtils";

interface MonthlyViewProps {
  habits: Habit[];
  days: Day[];
  selectedDay: string;
  selectedPeriod: ReportPeriod;
  notesEnabled: boolean;
  heatmapEnabled: boolean;
  onDayClick: (day: string) => void;
  onPeriodChange: (period: ReportPeriod) => void;
}

export const MonthlyView: React.FC<MonthlyViewProps> = ({
  habits,
  days,
  selectedDay,
  selectedPeriod,
  notesEnabled,
  heatmapEnabled,
  onDayClick,
  onPeriodChange,
}) => {
  const [currentTab, setCurrentTab] = useState<ReportTab>("habits");

  // Determine available tabs based on features enabled
  const availableTabs = () => {
    const tabs: { id: ReportTab; title: string }[] = [
      { id: "habits", title: "Habits" }
    ];
    
    if (notesEnabled) {
      tabs.push({ id: "journal", title: "Journal" });
    }
    
    return tabs;
  };

  const tabs = availableTabs();

  return (
    <div style={{ paddingBottom: "60px" }}>
      <div style={{ marginBottom: "20px" }}>
        <h2 style={{ marginBottom: "16px" }}>Reports</h2>
        
        {/* Tab Navigation - only show if notes are enabled */}
        {notesEnabled && (
          <div style={{ marginBottom: "16px" }}>
            <NavMenu
              selected={currentTab}
              items={tabs}
              onSelect={setCurrentTab}
            />
          </div>
        )}
      </div>

      {currentTab === "habits" ? (
        <>
          <div style={{ marginBottom: "20px" }}>
            <PeriodSelector
              selectedPeriod={selectedPeriod}
              onPeriodChange={onPeriodChange}
            />
          </div>

          {heatmapEnabled && (
            <ScoreHeatmap
              habits={habits}
              days={days}
              period={selectedPeriod}
              selectedDay={selectedDay}
              onDayClick={onDayClick}
            />
          )}

          <div style={{ marginTop: "30px" }}>
            <h3 style={{ marginBottom: "10px" }}>Last {getPeriodLabel(selectedPeriod)}</h3>
            <BarChart days={days} habits={habits} period={selectedPeriod} />
          </div>

          <ProgressTrackingWidget
            habits={habits}
            days={days}
            period={selectedPeriod}
          />
        </>
      ) : (
        <JournalView
          days={days}
        />
      )}
    </div>
  );
};